import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireModule } from '@angular/fire';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BlobModule } from 'angular-azure-blob-service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { LoaderModule } from './components/loader/loader.module';
import { MatNativeDateModule } from '@angular/material';
import { NgModule } from '@angular/core';
import { OnlineStatusComponent } from './components/online-status/online-status.component';
import { PopupModule } from './components/popup';
import { ToastNotificationModule } from './components/toast-notification/toast-notification.module';
import { environment } from 'src/environments/environment';
import { httpInterceptorProviders } from './services/interceptor';

@NgModule({
  declarations: [
    AppComponent,
    OnlineStatusComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LoaderModule,
    BlobModule.forRoot(),
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    ToastNotificationModule,
    MatNativeDateModule,
    PopupModule
  ],
  providers: [httpInterceptorProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }
